function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M38.897 14.435a13.02 13.02 0 0 1-3.686.986 6.304 6.304 0 0 0 2.822-3.463 13.039 13.039 0 0 1-4.075 1.52 6.484 6.484 0 0 0-4.683-1.978c-3.544 0-6.417 2.803-6.417 6.26 0 .49.057.968.166 1.427-5.333-.261-10.061-2.753-13.225-6.541-.553.925-.87 2-.87 3.147 0 2.172 1.134 4.088 2.855 5.21a6.508 6.508 0 0 1-2.906-.783v.08c0 3.032 2.211 5.562 5.147 6.138a6.574 6.574 0 0 1-2.898.107c.816 2.487 3.186 4.297 5.994 4.347a13.08 13.08 0 0 1-7.97 2.68c-.517 0-1.028-.03-1.53-.087a18.491 18.491 0 0 0 9.836 2.813c11.803 0 18.257-9.54 18.257-17.812 0-.27-.006-.541-.018-.81a12.852 12.852 0 0 0 3.2-3.24z",
  clipRule: "evenodd"
});

var SvgTw = function SvgTw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tw.a6e0f9b7.svg";
export { ForwardRef as ReactComponent };